import produce from 'immer';
import { createReducer } from 'typesafe-actions';
import {
  CREATE_CHANGE_ORDER,
  CREATE_CHANGE_ORDER_ERROR,
  CREATE_CHANGE_ORDER_SOV,
  CREATE_CHANGE_ORDER_SOV_ERROR,
  CREATE_CHANGE_ORDER_SOV_SUCCESS,
  CREATE_CHANGE_ORDER_SUCCESS,
  DELETE_CHANGE_ORDER,
  DELETE_CHANGE_ORDER_ERROR,
  DELETE_CHANGE_ORDER_SOV,
  DELETE_CHANGE_ORDER_SOV_ERROR,
  DELETE_CHANGE_ORDER_SOV_SUCCESS,
  DELETE_CHANGE_ORDER_SUCCESS,
  GET_CHANGE_ORDER_DETAIL,
  GET_CHANGE_ORDER_DETAIL_ERROR,
  GET_CHANGE_ORDER_DETAIL_SUCCESS,
  GET_CHANGE_ORDER_LIST,
  GET_CHANGE_ORDER_LIST_ERROR,
  GET_CHANGE_ORDER_LIST_SUCCESS,
  UPDATE_CHANGE_ORDER,
  UPDATE_CHANGE_ORDER_ERROR,
  UPDATE_CHANGE_ORDER_SOV,
  UPDATE_CHANGE_ORDER_SOV_ERROR,
  UPDATE_CHANGE_ORDER_SOV_SUCCESS,
  UPDATE_CHANGE_ORDER_SUCCESS,
} from './actions';
import { ChangeOrdersAction, ChangeOrdersState } from './types';

const initialState: ChangeOrdersState = {
  changeOrders: {
    loading: false,
    data: null,
    error: null,
  },
  changeOrder: {
    loading: false,
    data: null,
    error: null,
  },
};

const changeOrders = createReducer<ChangeOrdersState, ChangeOrdersAction>(
  initialState,
  {
    [GET_CHANGE_ORDER_LIST]: (state) => ({
      ...state,
      changeOrders: {
        loading: true,
        error: null,
        data: [],
      },
    }),

    [GET_CHANGE_ORDER_LIST_SUCCESS]: (state, action) => ({
      ...state,
      changeOrders: {
        loading: false,
        error: null,
        data: action.payload,
      },
    }),
    [GET_CHANGE_ORDER_LIST_ERROR]: (state, action) => ({
      ...state,
      changeOrders: {
        loading: false,
        error: action.payload,
        data: null,
      },
    }),

    // [CREATE_CHANGE_ORDER]: (state) =>
    //   produce(state, (draft) => {
    //     draft.changeOrder.loading = true;
    //     draft.changeOrder.error = null;
    //   }),
    // [CREATE_CHANGE_ORDER_SUCCESS]: (state, action) =>
    //   produce(state, (draft) => {
    //     draft.changeOrder.data = action.payload;
    //     draft.changeOrder.loading = false;
    //     draft.changeOrder.error = null;
    //   }),
    // [CREATE_CHANGE_ORDER_ERROR]: (state, action) =>
    //   produce(state, (draft) => {
    //     draft.changeOrder.loading = false;
    //     draft.changeOrder.error = action.payload;
    //   }),

    [CREATE_CHANGE_ORDER]: (state) =>
      produce(state, (draft) => {
        draft.changeOrders.loading = true;
        draft.changeOrders.error = null;
      }),

    [CREATE_CHANGE_ORDER_SUCCESS]: (state, action) =>
      produce(state, (draft) => {
        draft.changeOrders.data?.push(action.payload);
        draft.changeOrders.loading = false;
        draft.changeOrders.error = null;
      }),
    [CREATE_CHANGE_ORDER_ERROR]: (state, action) =>
      produce(state, (draft) => {
        draft.changeOrders.loading = false;
        draft.changeOrders.error = action.payload;
      }),

    [UPDATE_CHANGE_ORDER]: (state) =>
      produce(state, (draft) => {
        draft.changeOrder.loading = true;
        draft.changeOrder.error = null;
      }),
    [UPDATE_CHANGE_ORDER_SUCCESS]: (state, action) =>
      produce(state, (draft) => {
        draft.changeOrder.data = action.payload;
        if (draft.changeOrders.data !== null) {
          const index: number = draft.changeOrders.data.findIndex(
            (changeOrder) => changeOrder.id === draft.changeOrder.data!.id,
          );

          if (index !== -1) {
            draft.changeOrders.data[index] = draft.changeOrder.data;
          }
        }
        draft.changeOrder.loading = false;
        draft.changeOrder.error = null;
      }),
    [UPDATE_CHANGE_ORDER_ERROR]: (state, action) =>
      produce(state, (draft) => {
        draft.changeOrder.loading = false;
        draft.changeOrder.error = action.payload;
      }),

    [DELETE_CHANGE_ORDER]: (state) =>
      produce(state, (draft) => {
        draft.changeOrders.loading = true;
        draft.changeOrders.error = null;
      }),
    [DELETE_CHANGE_ORDER_SUCCESS]: (state, action) =>
      produce(state, (draft) => {
        if (draft.changeOrders.data !== null) {
          const index = draft.changeOrders.data.findIndex(
            (changeOrder) => changeOrder.id === action.payload,
          );
          draft.changeOrders.data.splice(index, 1);
        }
        draft.changeOrders.loading = false;
        draft.changeOrders.error = null;
      }),
    [DELETE_CHANGE_ORDER_ERROR]: (state, action) =>
      produce(state, (draft) => {
        draft.changeOrders.loading = false;
        draft.changeOrders.error = action.payload;
      }),

    [GET_CHANGE_ORDER_DETAIL]: (state) => ({
      ...state,
      changeOrder: {
        loading: true,
        error: null,
        data: null,
      },
    }),
    [GET_CHANGE_ORDER_DETAIL_SUCCESS]: (state, action) => ({
      ...state,
      changeOrder: {
        loading: false,
        error: null,
        data: action.payload,
      },
    }),
    [GET_CHANGE_ORDER_DETAIL_ERROR]: (state, action) => ({
      ...state,
      changeOrder: {
        loading: false,
        error: action.payload,
        data: null,
      },
    }),

    [CREATE_CHANGE_ORDER_SOV]: (state) =>
      produce(state, (draft) => {
        draft.changeOrder.loading = true;
        draft.changeOrder.error = null;
      }),
    [CREATE_CHANGE_ORDER_SOV_SUCCESS]: (state, action) =>
      produce(state, (draft) => {
        if (draft.changeOrder.data !== null) {
          draft.changeOrder.data.sov.push(action.payload);
          draft.changeOrder.loading = false;
          draft.changeOrder.error = null;
        }
      }),
    [CREATE_CHANGE_ORDER_SOV_ERROR]: (state, action) =>
      produce(state, (draft) => {
        draft.changeOrder.loading = false;
        draft.changeOrder.error = action.payload;
      }),

    [UPDATE_CHANGE_ORDER_SOV]: (state) =>
      produce(state, (draft) => {
        draft.changeOrder.loading = true;
        draft.changeOrder.error = null;
      }),
    [UPDATE_CHANGE_ORDER_SOV_SUCCESS]: (state, action) =>
      produce(state, (draft) => {
        if (draft.changeOrder.data !== null) {
          const index: number = draft.changeOrder.data.sov.findIndex(
            (sov: any) => sov.id === action.payload.id,
          );
          if (index !== -1) {
            draft.changeOrder.data.sov[index] = action.payload;
          }
        }
        draft.changeOrder.loading = false;
        draft.changeOrder.error = null;
      }),
    [UPDATE_CHANGE_ORDER_SOV_ERROR]: (state, action) =>
      produce(state, (draft) => {
        draft.changeOrder.loading = false;
        draft.changeOrder.error = action.payload;
      }),

    [DELETE_CHANGE_ORDER_SOV]: (state) =>
      produce(state, (draft) => {
        draft.changeOrder.loading = true;
        draft.changeOrder.error = null;
      }),
    [DELETE_CHANGE_ORDER_SOV_SUCCESS]: (state, action) =>
      produce(state, (draft) => {
        if (draft.changeOrder.data !== null) {
          const index = draft.changeOrder.data.sov.findIndex(
            (sov: any) => sov.id === action.payload,
          );
          draft.changeOrder.data.sov.splice(index, 1);
        }
        draft.changeOrder.loading = false;
        draft.changeOrder.error = null;
      }),
    [DELETE_CHANGE_ORDER_SOV_ERROR]: (state, action) =>
      produce(state, (draft) => {
        draft.changeOrder.loading = false;
        draft.changeOrder.error = action.payload;
      }),

    // [CREATE_EMPTY_CHANGE_ORDER_SOV]: (state) =>
    //   produce(state, (draft) => {
    //     draft.changeOrder.loading = true;
    //     draft.changeOrder.error = null;
    //   }),
    // [CREATE_EMPTY_CHANGE_ORDER_SOV_SUCCESS]: (state, action) =>
    //   produce(state, (draft) => {
    //     console.log(draft.changeOrder.data);
    //     console.log(action.payload);
    //     if (draft.changeOrder.data !== null) {
    //       draft.changeOrder.data.sov = action.payload;
    //       draft.changeOrder.loading = false;
    //       draft.changeOrder.error = null;
    //     }
    //   }),
    // [CREATE_EMPTY_CHANGE_ORDER_SOV_ERROR]: (state, action) =>
    //   produce(state, (draft) => {
    //     draft.changeOrder.loading = false;
    //     draft.changeOrder.error = action.payload;
    //   }),
  },
);

export default changeOrders;
